export default {"src":"/_next/static/media/20.03cc0701.svg","height":113,"width":113};